// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608310536/js/" + chunkId + "." + {"44":"b0c9c4cc","225":"75242edc","481":"b5724c2a","486":"87853ed6","770":"b824534e"}[chunkId] + ".0.7727328182755422.chunk.js";
};